<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="SERIES1">The Kantzer Lectures in Revealed Theology</p>
<p class="SERIES2">Sponsored by the<br/>Carl F. H. Henry Center for Theological Understanding,<br/>Trinity Evangelical Divinity School</p>
<p class="SERIES3">Series Editors</p>
<p class="SERIES4">Thomas H. McCall • Douglas A. Sweeney • Kevin J. Vanhoozer</p>
<p class="SERIES3">Published</p>
<p class="SERIES5"><em class="italic">The Election of Grace: A Riddle without a Resolution?</em><br/>Stephen N. Williams</p>
<p class="SERIES5"><em class="italic">The God We Worship: An Exploration of Liturgical Theology</em><br/>Nicholas Wolterstorff</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Williams_The_Election_of_Grace_text_CC-1.vue?9738b364